export default "__VITE_ASSET__0a4da55e__"